import { get, post, put, remove } from '../api';
import type { SecurityRule } from '../../../shared/model-typings';
import type { SBOMRule } from '../../../shared/model-typings/sbomrule';
import type { Policy } from '../../../typings/api';
import type { LicensingRule, PolicyId, QualityRule } from '../../types';

export const CREATE_POLICY_RULE = 'CREATE_POLICY_RULE';
export const DELETE_POLICY_RULE = 'DELETE_POLICY_RULE';
export const UPDATE_POLICY_RULE = 'UPDATE_POLICY_RULE';

export const FETCH_ALL_POLICIES = 'FETCH_ALL_POLICIES';
export const FETCH_ONE_POLICY = 'FETCH_ONE_POLICY';
export const UPDATE_POLICY = 'UPDATE_POLICY';
export const DELETE_POLICY = 'DELETE_POLICY';
export const CREATE_POLICY = 'CREATE_POLICY';

const PolicyActions = {
  fetchOne: (policyId: number) => ({
    type: FETCH_ONE_POLICY,
    meta: {
      id: policyId,
    },
    async payload() {
      return get(`/api/policies/${policyId}`, true);
    },
  }),
  update: (policy: Policy) => ({
    type: UPDATE_POLICY,
    async payload() {
      return put(`/api/policies/${policy.id}`, policy);
    },
  }),
  fetchAll: () => ({
    type: FETCH_ALL_POLICIES,
    async payload() {
      return get(`/api/policies`);
    },
  }),
  create: (policy: Policy) => ({
    type: CREATE_POLICY,
    async payload() {
      return post(`/api/policies`, policy);
    },
  }),
  import: ({ title, description, policyFile } : {
    title?: string | null,
    description?: string | null,
    policyFile: File,
  }) => ({
    type: CREATE_POLICY,
    async payload() {
      const formData = new FormData();
      formData.append('policyFile', policyFile);
      if (title) {
        formData.append('title', title);
      }
      if (description) {
        formData.append('description', description || '');
      }
      // TODO: can this be done with the redux/api util?
      const response = await fetch(
        `/api/policies/import`,
        {
          method: 'POST',
          body: formData,
          headers: {
            'CSRF-Token': window._csrf,
          },
        },
      );
      const data = await response.json();
      if (!response?.ok) {
        throw new Error(data?.message || 'Error uploading policy');
      }

      return { data };
    },
  }),
  delete: (policyId: number) => {
    return {
      type: DELETE_POLICY,
      meta: {
        id: policyId,
      },
      async payload() {
        return remove(`/api/policies/${policyId}`);
      },
    };
  },
  createPolicyRule: (policyId: PolicyId, rule: LicensingRule | QualityRule) => ({
    type: CREATE_POLICY_RULE,
    async payload() {
      return post(`/api/policies/${policyId}/rules`, rule);
    },
  }),

  deletePolicyRule: (policyId: PolicyId, ruleId: number) => ({
    type: DELETE_POLICY_RULE,
    async payload() {
      return remove(`/api/policies/${policyId}/rules/${ruleId}`);
    },
  }),

  updatePolicyRule: (
    policyId: PolicyId,
    editedRuleId: number,
    rule: Partial<LicensingRule | SecurityRule | QualityRule | SBOMRule>,
  ) => ({
    type: UPDATE_POLICY_RULE,
    async payload() {
      return put(`/api/policies/${policyId}/rules/${editedRuleId}`, rule);
    },
  }),
};

export default PolicyActions;
